'use client'
import {
  DecoratedSection_default
} from "./chunk-HJCFOVNG.mjs";

// src/components/groups/GroupsTable.tsx
import { LeagueGroup } from "@wbk/ticketing";
import { useGetEventsGroupDetails, useGetOrganizationBySlug } from "@wbk/api/hooks";
import { Typography } from "@wbk/ui";
import { useRouter, useTranslation } from "@wbk/config";
import { jsx, jsxs } from "react/jsx-runtime";
var GroupsTable = ({ section }) => {
  const organizationSlug = section.organizationSlug;
  const { locale } = useRouter();
  useTranslation(["ticketing_league"]);
  const {
    data: orgData,
    isLoading: orgLoading,
    error: orgError
  } = useGetOrganizationBySlug(
    { lang: locale, slug: organizationSlug },
    { enabled: !!organizationSlug }
  );
  const { data, isLoading, error } = useGetEventsGroupDetails(
    { lang: locale, organizationsSlug: organizationSlug },
    { enabled: !!organizationSlug }
  );
  const anyGroupHasPointsTable = data == null ? void 0 : data.some((g) => g.points_table);
  if (orgLoading || isLoading) {
    return /* @__PURE__ */ jsxs("section", { className: "container animate-pulse space-y-5 py-10", children: [
      /* @__PURE__ */ jsx("div", { className: "bg-paper-level-2 rounded-S h-10 w-32" }),
      /* @__PURE__ */ jsx("div", { className: "space-y-4", children: /* @__PURE__ */ jsx("div", { className: "bg-paper-level-2 aspect-1 rounded-S h-64 w-full" }) })
    ] });
  }
  if (error || orgError || !anyGroupHasPointsTable || !data || !orgData) return null;
  return /* @__PURE__ */ jsxs(DecoratedSection_default, { section, className: "container", children: [
    section.title && /* @__PURE__ */ jsxs("div", { className: "space-y-1", children: [
      /* @__PURE__ */ jsx(Typography, { as: "h2", variant: "heading-L", children: section.title }),
      section.subtitle && /* @__PURE__ */ jsx(Typography, { color: "text-secondary", className: "mt-1", children: section.subtitle })
    ] }),
    /* @__PURE__ */ jsx("div", { className: "space-y-4", children: data.map((group, i) => /* @__PURE__ */ jsx("div", { className: "relative shrink-0 basis-80 md:basis-96 ltr:mr-4 rtl:ml-4", children: /* @__PURE__ */ jsx(LeagueGroup, { group, teams: orgData.teams }, group._id) }, i)) })
  ] });
};
var GroupsTable_default = GroupsTable;

export {
  GroupsTable_default
};
//# sourceMappingURL=chunk-AZT4MYPZ.mjs.map